import { Box, Flex, Text } from "@storyofams/react-ui";

export const OptionTitle = ({ isPicked, title, onOptionClick }) => {
  return (
    <Box
      width="100%"
      border={isPicked ? "1px solid #1D1D1B" : "1px solid #E2DFDF"}
      py={["16px", "11px"]}
      px={[1, "16px"]}
      borderRadius={"8px"}
      as="button"
      position={"relative"}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onOptionClick(title);
      }}
    >
      <Flex alignItems={"center"}>
        <Box
          width={16}
          border="1px solid black"
          height={16}
          borderRadius={"full"}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          mr={1}
        >
          {isPicked && (
            <Box
              width={6}
              border="1px solid black"
              height={6}
              backgroundColor={"black"}
              borderRadius={"full"}
            />
          )}
        </Box>
        <Text
          textAlign={"start"}
          fontWeight={600}
          lineHeight={"22px"}
          fontSize={2}
        >
          {title}
        </Text>
      </Flex>
    </Box>
  );
};
